import { IconStack, IconStack2, IconStack3 } from '@tabler/icons-react'
import { ReactNode } from 'react'

import { AstraChip, AstraChipProps, AstraIcon } from '~/astra'
import { AgeGroupCode, SurgeryTypeGroupEnum } from '~/clients/derived-api-types'
import { AgeGroup } from '~/components'

type Props = {
    text: string
    groupLevel: SurgeryTypeGroupEnum | 'none'
    ageCategory?: AgeGroupCode | null
} & AstraChipProps

export const RuleValuesChip = ({ groupLevel, ageCategory, text, size, fullWidth, ref, ...props }: Props) => {
    const iconByGroupLevel: Record<SurgeryTypeGroupEnum | 'none', ReactNode> = {
        category: <AstraIcon icon={IconStack} color="text-muted" />,
        composite: <AstraIcon icon={IconStack2} color="text-muted" />,
        speciality: <AstraIcon icon={IconStack3} color="text-muted" />,
        subspeciality: <AstraIcon icon={IconStack2} color="text-muted" />,
        none: <></>,
    }
    return (
        <div className="flex items-center">
            <AstraChip
                ref={ref}
                variant="filled"
                icon={iconByGroupLevel[groupLevel]}
                size={size}
                fullWidth={fullWidth}
                label={text}
                truncated
                endIcon={<AgeGroup iconOnly ageGroupCode={ageCategory} />}
                {...props}
            />
        </div>
    )
}
